import React, {useState} from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import {dropdownFill, dropdownGrey} from '../../assets/images/images';

const isProfiledRisk = localStorage
  ?.getItem('subdomain')
  ?.includes('profiledrisk');

const isTrypila = localStorage?.getItem('subdomain')?.includes('trypila');

export const isVeldro = localStorage?.getItem('subdomain')?.includes('veldro');

export const SubNavigationDropdown = ({
  toggleSubRoute,
  src,
  open,
  label,
  IconComponent,
  subRoutes,
  isChildHovered,
  isEnabled,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();

  const getBasePath = path => {
    if (!path || path === '/') return path;
    const parts = path.split('/').filter(Boolean);
    return parts.length > 0 ? `/${parts[0]}` : path;
  };

  const isActive = subRoutes?.some(route => {
    const routeBasePath = getBasePath(route);
    const currentBasePath = getBasePath(location.pathname);
    return currentBasePath === routeBasePath;
  });

  return (
    <button
      className={`${isEnabled} flex sub-nav-item mb-1 items-center rounded-t-lg gap-2 h-[38px] py-2 px-3 cursor-pointer relative ${
        isActive || isChildHovered ? 'active' : ''
      } ${isHovered ? 'hover:bg-white hover:text-deepBlue' : 'text-[#AEB3C7]'}`}
      onClick={toggleSubRoute}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {IconComponent ? (
        <IconComponent
          isHovered={isHovered}
          isActive={isActive || isChildHovered}
        />
      ) : (
        <img src={src} alt="" width={18} height={18} />
      )}
      <span className="text-sm font-light">{label}</span>
      <img
        src={
          isHovered || isActive || isChildHovered ? dropdownGrey : dropdownFill
        }
        alt=""
        className={`absolute right-4 ${
          open
            ? '-rotate-180 ease-in duration-300 transition'
            : 'rotate-0 ease-out duration-300 transition'
        }`}
        width={14}
        height={14}
      />
    </button>
  );
};

export const SubNavigationItem = ({title, to, className, onHoverChange}) => {
  const isError = sessionStorage?.resetErrorBoundary;

  return (
    <NavLink
      to={to}
      className={({isActive}) =>
        `flex items-center gap-2 ${
          isTrypila
            ? 'nav-sub-item-trypila'
            : isProfiledRisk || isVeldro
            ? 'nav-sub-item-profiled-risk'
            : 'nav-sub-item'
        } ${className} h-[38px] py-2 pl-[38px] pr-2 relative ${
          isActive ? 'active' : ''
        }`
      }
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
      aria-current="page"
      {...(isError === 'true'
        ? {
            onClick: () => {
              location.href = to;
              sessionStorage.removeItem('resetErrorBoundary');
            },
          }
        : {})}
    >
      <span className="text-sm font-light">{title}</span>
    </NavLink>
  );
};

export const NavigationItem = ({
  mobileIcon,
  webIcon,
  media,
  title,
  to,
  IconComponent,
  isEnabled,
}) => {
  const icon = media ? webIcon : mobileIcon;
  const isError = sessionStorage?.resetErrorBoundary;
  const location = useLocation();

  const getBasePath = path => {
    if (!path || path === '/') return path;
    const parts = path.split('/').filter(Boolean);
    return parts.length > 0 ? `/${parts[parts.length - 1]}` : path;
  };

  const isActive = getBasePath(location.pathname) === getBasePath(to);

  return (
    <NavLink
      to={to}
      exact="true"
      className={({isActive: navLinkIsActive}) =>
        `${isEnabled} nav-item flex items-center gap-2 mb-1 h-[38px] text-[#AEB3C7] py-2 px-3 relative ${
          navLinkIsActive || isActive ? 'active' : ''
        }`
      }
      aria-current="page"
      {...(isError === 'true'
        ? {
            onClick: () => {
              location.href = to;
              sessionStorage.removeItem('resetErrorBoundary');
            },
          }
        : {})}
    >
      {({isActive: navLinkIsActive}) => (
        <>
          {IconComponent ? (
            <IconComponent active={navLinkIsActive || isActive} />
          ) : (
            <img src={icon} alt="" width={18} height={18} />
          )}
          <span className="text-sm font-light">{title}</span>
        </>
      )}
    </NavLink>
  );
};
